// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import { canPlay, MATCH_URL_STREAMABLE } from '../../../constants';
import { defaultProps } from '../props';
import type { BaseReactPlayerProps } from '../types';
import { callPlayer, getSDK } from '../utils';

const SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
const SDK_GLOBAL = 'playerjs';

export class Streamable extends Component<BaseReactPlayerProps> {
  static defaultProps = defaultProps;

  static canPlay = canPlay.streamable;

  callPlayer = callPlayer;

  duration = null;

  currentTime = null;

  secondsLoaded = null;

  componentDidMount() {
    this.props.onMount?.(this);
  }

  load() {
    getSDK(SDK_URL, SDK_GLOBAL).then((playerjs) => {
      if (!this.iframe) return;

      const {
        onReady,
        onPlay,
        onPause,
        onError,
        onSeek,
        onEnded,
        muted,
        loop
      } = this.props;

      this.player = new playerjs.Player(this.iframe);
      this.player.setLoop(loop);
      this.player.on('ready', onReady);
      this.player.on('play', onPlay);
      this.player.on('pause', onPause);
      this.player.on('seeked', onSeek);
      this.player.on('ended', onEnded);
      this.player.on('error', onError);
      this.player.on('timeupdate', ({ duration, seconds }) => {
        this.duration = duration;
        this.currentTime = seconds;
      });

      this.player.on('buffered', ({ percent }) => {
        if (this.duration) {
          this.secondsLoaded = this.duration * percent;
        }
      });

      if (muted) {
        this.player.mute();
      }
    }, this.props.onError);
  }

  play() {
    this.callPlayer('play');
  }

  pause() {
    this.callPlayer('pause');
  }

  stop() {
    // Nothing to do
  }

  seekTo(seconds) {
    this.callPlayer('setCurrentTime', seconds);
  }

  setVolume(fraction) {
    this.callPlayer('setVolume', fraction * 100);
  }

  setLoop(loop) {
    this.callPlayer('setLoop', loop);
  }

  mute = () => {
    this.callPlayer('mute');
  };

  unmute = () => {
    this.callPlayer('unmute');
  };

  getDuration() {
    return this.duration;
  }

  getCurrentTime() {
    return this.currentTime;
  }

  getSecondsLoaded() {
    return this.secondsLoaded;
  }

  ref = (iframe) => {
    this.iframe = iframe;
  };

  render() {
    const { url } = this.props;

    const id = url.match(MATCH_URL_STREAMABLE)[1];
    const style = {
      width: '100%',
      height: '100%'
    };

    return (
      <iframe
        ref={this.ref}
        title="Streamable Player"
        src={`https://streamable.com/o/${id}`}
        frameBorder="0"
        scrolling="no"
        style={style}
        allow="encrypted-media; autoplay; fullscreen;"
      />
    );
  }
}
